import React, { useEffect, useState, useMemo } from "react";
import {
  FormControl,
  MenuItem,
  Select,
  Typography,
  InputLabel,
} from "@mui/material";
import { fetchAllDistrict } from "../action";
import { useDispatch, useSelector } from "react-redux";
import { decodeId, parseData } from "../utils/helper";
import { useTranslation } from "react-i18next";

import styled from "styled-components";
const Content = styled(Typography)`
  margin-bottom: 0.5rem;
`;
const DistrictPicker = ({
  input,
  value,
  reset,
  userHealthFacilityFullPath,
  withLabel = true,
  label = null,
  required = false,
  allRegions,
  error,
  meta,
  region,
  ...props
}) => {
  const [selectedValue, setSelectedValue] = useState();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    if (region?.region) dispatch(fetchAllDistrict(region?.region));
  }, [region]);
  // }, [allRegions, dispatch]);
  const handleChange = (event) => {
    const selectedRegion = event.target.value;
    setSelectedValue(selectedRegion);
  };

  const regionData = useSelector(
    (state) => state?.profileReducer?.locationDistrictResponseData
  );
  
  return (
    <>
      <Content>
        <Typography required={required} color="#666666">
          {label} {required ? "*" : ""}
        </Typography>
      </Content>
      <FormControl fullWidth>
        <Select
          value={value}
          onChange={handleChange}
          displayEmpty
          required={required}
          size="small"
          error={meta && meta.touched && meta.error && error}
          {...input}
          {...props}
        >
          <MenuItem disabled value="">
            <em>{t("Select")}</em>
          </MenuItem>
          {regionData &&
            regionData.map((region) => (
              <MenuItem key={region.id} value={region.id}>
                {region.name}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </>
  );
};

export default DistrictPicker;
